import AbmVideotutoriales from "../../components/textos/AbmVideotutoriales/AbmVideotutoriales";

export const configTable = {
    urls: [
        "/Texto/GetByIdTipoTexto/17?Pagina=1&RegistrosPorPagina=-1", // GET
        "/Texto", // POST 
        "/Texto", // PUT
        "/Texto" // DELETE
    ],
    grid: {
        columnConfig: ["id","nombre", "descripcion"], // cuidado con el orden de los strings
        searchField: ["nombre", "id", "descripcion"]
    },
    Abm: AbmVideotutoriales,
    textSize: 10
}